import { useConnect } from '@hooks/useConnect'
import { Button } from '@ui'
import { getPlugExtension } from '@utils/plugExtension'
import { WALLET_SETUP_ROUTES } from '@utils/walletSetupRoutes'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { SetupStep } from './SetupStep'

export const ConnectPlug = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { connectingProvider, onConnect } = useConnect()

  const plug = getPlugExtension()

  return (
    <SetupStep
      title={t('welcome.connectPlugWallet.title')}
      description={t('welcome.connectPlugWallet.description')}
    >
      <div className="flex flex-col gap-4">
        <Button
          variant="primary"
          fullWidth
          disabled={!!connectingProvider}
          onClick={() => navigate(WALLET_SETUP_ROUTES.IMPORT_SEED)}
        >
          {t('welcome.connectPlugWallet.importSeed')}
        </Button>

        {!!plug && (
          <Button
            variant="secondary"
            fullWidth
            disabled={!!connectingProvider}
            loading={!!connectingProvider}
            onClick={() => onConnect('plug')}
          >
            {t('welcome.connectPlugWallet.plugExtension')}
          </Button>
        )}

        <Button variant="secondary" fullWidth onClick={() => navigate(-1)}>
          {t('common.back')}
        </Button>
      </div>
    </SetupStep>
  )
}
